import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { debugLog } from 'shared/logger/debugLog';
import { documentationContract } from 'shared/domain/documentation/documentationContract';
import { makeErrorPublisher } from 'serviceWorker/broadcasts/publishers';

export const broadcastDocumentationVersionError = makeErrorPublisher(
  documentationContract
);

export const broadcastUpdatedDocumentationVersionError = (
  error: any
): void => {
  debugLog('broadcastUpdatedDocumentationVersionError', error);
  broadcastDocumentationVersionError(
    DomainMessagesTypes.updatedEntity,
    error
  );
};
